const Upload = {
  path: "",
  name: "",
  redirect: "/upload",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/upload",
      redirect: "/upload",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Upload",
      meta: {
        requiresAuth: true,
        activeUrl: "/upload",
        parent: "/upload",
        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/upload"),
          meta: {
            requiresAuth: true,
            activeUrl: "/upload",
            parent: "/upload",

            lv: 2,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Upload;
